import { render, staticRenderFns } from "./GridField.vue?vue&type=template&id=124fb099&scoped=true&"
import script from "./GridField.vue?vue&type=script&lang=js&"
export * from "./GridField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124fb099",
  null
  
)

export default component.exports